import React, { useContext, useEffect } from 'react'
import { Switch, Route, useLocation } from 'react-router-dom'
import PagePresentation from './views/PagePresentation';
import PageVideos from './views/PageVideos';
import { NavigationContext } from './context/NavigationContext';
import ContentBox from './components/ContentBox';
import NavigationMenu from './components/NavigationMenu';
import NavigationLinks from './components/NavigationLinks';
import NavBar from './components/NavBar';
import PageModalites from './views/PageModalites';
import PageTutoriels from './views/PageTutoriels';
import VideoPresentation from './views/VideoPresentation';
import VideoPix from './views/VideoPix';
import PageQuizz from './views/PageQuizz';
import VideoModalites from './views/VideoModalites';
import VideoOrganisation from './views/VideoOrganisation';
import MenuMobile from './components/MenuMobile';

function App() {
    const { page, setPage, setMenuVisible } = useContext(NavigationContext)
    const location = useLocation()

    useEffect(() => {
        switch (new URLSearchParams(location.search).get('page')) {
            case "tutoriels":
                setPage('tutoriels')
                break;
            case "quizz":
                setPage('quizz')
                break;
            case "modalites":
                setPage('modalites')
                break;
            case "videos":
                setPage('videos')
                break;
            default:
                setPage('presentation')
                break;
        }
    }, [])

    const component = () => {
        switch (new URLSearchParams(location.search).get('page')) {
            case "tutoriels":
                return <PageTutoriels />
            case "quizz":
                return <PageQuizz />
            case "modalites":
                return <PageModalites />
            case "videos":
                switch (new URLSearchParams(location.search).get('id')) {
                    case "presentation":
                        return <VideoPresentation />
                    case "organisation":
                        return <VideoOrganisation />
                    case "modalites":
                        return <VideoModalites />
                    case "pix":
                        return <VideoPix />
                    default:
                        return <PageVideos />
                }
            default:
                return <PagePresentation />
        }
    }

    return (
        <div className="App">
            <NavBar />
            <div className="main-content">
                <div className="left">
                    <NavigationMenu />
                    <NavigationLinks />
                </div>
                <div className="right">
                    <MenuMobile />
                    <ContentBox>
                        {component()}
                    </ContentBox>
                </div>
            </div>
        </div>
    );
}

export default App;
